export default __webpack_public_path__ + "static/media/city_img_adelaide.64fc1329.png";